const FormatPrice = (price: string) => {
    const value = parseFloat(price);
    const formattedValue = value.toLocaleString().replace(/\./, " ");

    return formattedValue;
}
export default FormatPrice;